export default __webpack_public_path__ + "static/3D-modeling-c5137fcc0a15820cfd0b4645e913850a.webp";